/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4558:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GQ: () => (/* binding */ swsitsSettings)
/* harmony export */ });
/* unused harmony exports swsitsEvents, swsitsTheme, swsitsStrings, swsitsLibs */
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8971);
/* harmony import */ var _libs_loadjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9280);
/* harmony import */ var _libs_loadjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_libs_loadjs__WEBPACK_IMPORTED_MODULE_0__);


window.swsitsEvents = window.swsitsEvents || new _utils_events__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
window._ThemeEvent = window.swsitsEvents;
window.swsitsLibs.loadjs = __loadjs;
const swsitsEvents = window.swsitsEvents;
const swsitsTheme = window.swsitsTheme || {};
const swsitsSettings = window.swsitsSettings || {};
const swsitsStrings = window.swsitsStrings || {};
const swsitsLibs = window.swsitsLibs || {};

/***/ }),

/***/ 9280:
/***/ (() => {

__loadjs = function () {
  var h = function () {},
    c = {},
    u = {},
    f = {};
  function o(e, n) {
    if (e) {
      var r = f[e];
      if (u[e] = n, r) for (; r.length;) r[0](e, n), r.splice(0, 1);
    }
  }
  function l(e, n) {
    e.call && (e = {
      success: e
    }), n.length ? (e.error || h)(n) : (e.success || h)(e);
  }
  function d(r, t, s, i) {
    var c,
      o,
      e = document,
      n = s.async,
      u = (s.numRetries || 0) + 1,
      f = s.before || h,
      l = r.replace(/[\?|#].*$/, ""),
      a = r.replace(/^(css|img)!/, "");
    i = i || 0, /(^css!|\.css$)/.test(l) ? ((o = e.createElement("link")).rel = "stylesheet", o.href = a, (c = "hideFocus" in o) && o.relList && (c = 0, o.rel = "preload", o.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(l) ? (o = e.createElement("img")).src = a : ((o = e.createElement("script")).src = r, o.async = void 0 === n || n), !(o.onload = o.onerror = o.onbeforeload = function (e) {
      var n = e.type[0];
      if (c) try {
        o.sheet.cssText.length || (n = "e");
      } catch (e) {
        18 != e.code && (n = "e");
      }
      if ("e" == n) {
        if ((i += 1) < u) return d(r, t, s, i);
      } else if ("preload" == o.rel && "style" == o.as) return o.rel = "stylesheet";
      t(r, n, e.defaultPrevented);
    }) !== f(r, o) && e.head.appendChild(o);
  }
  function r(e, n, r) {
    var t, s;
    if (n && n.trim && (t = n), s = (t ? r : n) || {}, t) {
      if (t in c) throw "LoadJS";
      c[t] = !0;
    }
    function i(n, r) {
      !function (e, t, n) {
        var r,
          s,
          i = (e = e.push ? e : [e]).length,
          c = i,
          o = [];
        for (r = function (e, n, r) {
          if ("e" == n && o.push(e), "b" == n) {
            if (!r) return;
            o.push(e);
          }
          --i || t(o);
        }, s = 0; s < c; s++) d(e[s], r, n);
      }(e, function (e) {
        l(s, e), n && l({
          success: n,
          error: r
        }, e), o(t, e);
      }, s);
    }
    if (s.returnPromise) return new Promise(i);
    i();
  }
  return r.ready = function (e, n) {
    return function (e, r) {
      e = e.push ? e : [e];
      var n,
        t,
        s,
        i = [],
        c = e.length,
        o = c;
      for (n = function (e, n) {
        n.length && i.push(e), --o || r(i);
      }; c--;) t = e[c], (s = u[t]) ? n(t, s) : (f[t] = f[t] || []).push(n);
    }(e, function (e) {
      l(n, e);
    }), r;
  }, r.done = function (e) {
    o(e, []);
  }, r.reset = function () {
    c = {}, u = {}, f = {};
  }, r.isDefined = function (e) {
    return e in c;
  }, r;
}();

/***/ }),

/***/ 8971:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ Event)
/* harmony export */ });
/* unused harmony export addEventDelegate */
const addEventDelegate = _ref => {
  let {
    context = document.documentElement,
    event = 'click',
    selector,
    handler,
    capture = false
  } = _ref;
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
};
class Event {
  constructor() {
    this.events = {};
  }
  get evts() {
    return Object.keys(this.events);
  }
  subscribe(event, handler) {
    this.events[event] = this.events[event] || [];
    this.events[event].push(handler);
    return () => this.unSubscribe(event, handler);
  }
  unSubscribe(event, handler) {
    const handlers = this.events[event];
    if (handlers && Array.isArray(handlers)) {
      for (let i = 0; i < handlers.length; i++) {
        if (handlers[i] === handler) {
          handlers.splice(i, 1);
          break;
        }
      }
    }
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    console.groupCollapsed(`Event emitted: ${event}`);
    console.trace();
    console.groupEnd();
    (this.events[event] || []).forEach(handler => {
      handler(...args);
    });
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./src/js/pages/product/sticky-atc.js
/* provided dependency */ var swsitsSettings = __webpack_require__(4558)["GQ"];

if (!customElements.get("sticky-atc")) {
  customElements.define("sticky-atc", class StickyAtc extends HTMLElement {
    constructor() {
      super();
      _defineProperty(this, "setObserveTarget", () => {
        if (this.observer) {
          this.observer.observe(this.productFormActions);
          this.observeTarget = this.productFormActions;
        }
      });
      this.selectors = {
        prodTitle: ".psa__title",
        mainImage: ".spc__main-img",
        atc: ".add-to-cart",
        buyNowBtn: ".prod__dynamic_checkout",
        variantIdSelect: '[name="id"]'
      };
      document.body.classList.add("sticky-atc-bar-enabled");
      this.hasCustomFields = !!document.querySelector(".sf-prod-template__desktop .product__custom-field");
    }
    connectedCallback() {
      var _this$mainProduct, _this$mainProduct2;
      this.productFormActions = document.querySelector(".f-product-form");
      this.container = this.closest(".prod__sticky-atc");
      this.mainProduct = document.querySelector(".main-product.product-form");
      this.mainATCButton = (_this$mainProduct = this.mainProduct) === null || _this$mainProduct === void 0 ? void 0 : _this$mainProduct.querySelector(this.selectors.atc);
      this.mainProductDynamic = (_this$mainProduct2 = this.mainProduct) === null || _this$mainProduct2 === void 0 ? void 0 : _this$mainProduct2.querySelector(this.selectors.buyNowBtn);
      this.stickyATCBar = document.querySelector(".prod__sticky-atc");
      this.productId = this.dataset.productId;
      this.domNodes = queryDomNodes(this.selectors, this.stickyATCBar);
      this.variantData = this.getVariantData();
      this.init();
      this.setStickyAddToCartHeight();
      this.addEventListener('change', () => {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId));
        this.updateButton(true, '', false);
        if (!this.currentVariant) {
          this.updateButton(true, '', true);
        } else {
          this.updateButton(!this.currentVariant.available, window.swsitsStrings.soldOut);
        }
      });
      document.addEventListener('matchMobile', () => {
        this.setStickyAddToCartHeight();
      });
      document.addEventListener('unmatchMobile', () => {
        this.setStickyAddToCartHeight();
      });
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    init() {
      if (!this.mainATCButton) {
        this.container.classList.remove("translate-y-full");
        return;
      }
      const {
        prodTitle,
        mainImage,
        atc,
        buyNowBtn
      } = this.domNodes;
      if (buyNowBtn) this.enable_dynamic_checkout = true;
      // const isMobile = window.matchMedia("(max-width: 639px)");
      // isMobile.addEventListener("change", this.checkDevice.bind(this));

      // this.checkDevice(isMobile); 

      const headerHeight = swsitsSettings.headerHeight || 66;
      const rootMargin = `-${headerHeight}px 0px 0px 0px`;
      if ("IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const method = entry.intersectionRatio !== 1 ? "remove" : "add";
            this.container.classList[method]("translate-y-full");
            document.documentElement.classList[entry.intersectionRatio != 1 ? "remove" : "add"]("stick-atc-show");
          });
        }, {
          threshold: 1,
          rootMargin
        });
      }
      prodTitle === null || prodTitle === void 0 ? void 0 : prodTitle.addEventListener("click", window.swsitsLibs.scrollToTop);
      mainImage === null || mainImage === void 0 ? void 0 : mainImage.addEventListener("click", window.swsitsLibs.scrollToTop);
      if (this.hasCustomFields) {
        atc.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          window.swsitsLibs.scrollToTop(() => this.mainATCButton.click());
        });
        if (buyNowBtn) {
          buyNowBtn.addEventListener("click", e => {
            const missing = validateForm(this.mainProduct);
            if (missing.length > 0) {
              e.preventDefault();
              e.stopPropagation();
              window.swsitsLibs.scrollToTop(() => {
                var _this$mainProductDyna;
                return (_this$mainProductDyna = this.mainProductDynamic) === null || _this$mainProductDyna === void 0 ? void 0 : _this$mainProductDyna.click();
              });
            }
          }, true);
        }
      }
      this.setObserveTarget();
      this.syncWithMainProductForm();
    }
    checkDevice(e) {
      const sectionHeight = this.clientHeight + "px";
      document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
    }
    updateButton() {
      let disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      let text = arguments.length > 1 ? arguments[1] : undefined;
      let modifyClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      const productForm = this.querySelector('.sticky-atc-form');
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > .atc-text');
      const preorder = productForm.dataset.preorder;
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('disabled');
        if (preorder === "true") {
          addButtonText.textContent = window.swsitsStrings.preorder;
        } else {
          addButtonText.textContent = window.swsitsStrings.addToCart;
        }
      }
    }
    syncWithMainProductForm() {
      const variantInput = this.querySelector('[name="id"]');
      window.swsitsEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async variant => {
        if (!variant) return;
        variantInput.value = variant.id;
        this.currentVariant = variant;
        this.updateButton(!variant.available, window.swsitsStrings.soldOut);
      });
    }
    setStickyAddToCartHeight() {
      document.documentElement.style.setProperty('--f-sticky-atc-bar-height', this.offsetHeight + 'px');
      window.swsitsSettings.stickyAddToCartHeight = this.offsetHeight;
    }
  });
}
})();

/******/ })()
;
